import validatorRegistry from "./validatorRegistry";

function checkEmpty(value) {
  return (!value.toString().trim()) ? "Field cannot be empty" : null;
}

function checkNumerical(value) {
  return (/^[0-9\s]+$/.test(value.trim())) ? "Field cannot contain only numbers" : null;
}

function checkUuid(value) {
  return (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value.trim())) ? "Field must contain a valid Uuid" : null;
}

function checkEmail(value) {
  return (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())) ? "Field must contain a valid email address" : null;
}

function checkIp(value) {
  return (!/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(value.trim())) ? "Field must contain a valid ip address" : null;
}

function checkDeviceTypeInRange(value) {
  let range = window.appConfig && window.appConfig.deviceTypes;
  var validValues = range.map((item) => item.value);

  if (validValues.includes(value)) {
    return null;
  } else {
    return "Field value not in set";
  }
}

function checkBrandFamilyInRange(value) {
  const all = (window.appConfig?.deviceTypes ?? [])
    .flatMap(t => t.brandAndFamily ?? [])
    .map(o => o.value ?? "");
  const v = value ?? "";

  return v === "" || all.includes(v) ? null : "Field value not in set";
}

function checkPreferenceTypeInRange(value) {
  let range = window.appConfig && window.appConfig.preferenceTypes;
  var validValues = range.map((item) => item.value);

  if (validValues.includes(value)) {
    return null;
  } else {
    return "Field value not in set";
  }
}

function checkCapacityTariffTypeInRange(value) {
  let range = window.appConfig && window.appConfig.capacityTariffTypes;
  var validValues = range.map((item) => item.value);

  if (validValues.includes(value)) {
    return null;
  } else {
    return "Field value not in set";
  }
}

function checkEnergyTariffTypeInRange(value) {
  let range = window.appConfig && window.appConfig.energyTariffTypes;
  var validValues = range.map((item) => item.value);

  if (validValues.includes(value)) {
    return null;
  } else {
    return "Field value not in set";
  }
}

function checkOrientationTypeInRange(value) {
  let range = window.appConfig && window.appConfig.orientationTypes;
  var validValues = range.map((item) => item.value);

  if (validValues.includes(value)) {
    return null;
  } else {
    return "Field value not in set";
  }
}

function checkLanguageCodeInRange(value) {
  let range = window.appConfig && window.appConfig.languageCodes;
  var validValues = range.map((item) => item.value);

  if (validValues.includes(value)) {
    return null;
  } else {
    return "Field value not in set";
  }
}

function checkLatitude(value) {
  try {
    const num = parseFloat(value.toString().trim());
    if (isNaN(num) || num < -90 || num > 90) {
      return "Field must contain a number between -90 and 90";
    }
    return null;
  } catch (e) {
    return "Field must contain a number between -90 and 90";
  }
}

function checkLongitude(value) {
  try {
    const num = parseFloat(value.toString().trim());
    if (isNaN(num) || num < -180 || num > 180) {
      return "Field must contain a number between -180 and 180";
    }
    return null;
  } catch (e) {
    return "Field must contain a number between -180 and 180";
  }
}

function checkIsPositiveInt(value) {
  const trimmed = value.toString().trim();
  return (/^(0|[1-9]\d*)$/.test(trimmed))
    ? null
    : "Field must be an integer greater than or equal to 0";
}

function checkIsValidNumber(value) {
  const trimmed = value.toString().trim();
  if (trimmed === "") {
    return "Field cannot be empty";
  }
  const num = Number(trimmed);
  return isNaN(num) ? "Field must be a valid number" : null;
}

function checkIsValidNumberInRange0_100(value) {
  const trimmed = value.toString().trim();
  if (trimmed === "") {
    return "Field cannot be empty";
  }
  const num = Number(trimmed);
  if (isNaN(num)) {
    return "Field must be a number between 0 and 100";
  }
  if (num < 0 || num > 100) {
    return "Field must be a number between 0 and 100";
  }
  return null;
}

function checkIsValidNumberInRange0_360(value) {
  const trimmed = value.toString().trim();
  if (trimmed === "") {
    return "Field cannot be empty";
  }
  const num = Number(trimmed);
  if (isNaN(num)) {
    return "Field must be a number between 0 and 360";
  }
  if (num < 0 || num >= 360) {
    return "Field must be a number between 0 and 360";
  }
  return null;
}

function checkIsValidNumberInRangeMinus90_90(value) {
  const trimmed = value.toString().trim();
  if (trimmed === "") {
    return "Field cannot be empty";
  }
  const num = Number(trimmed);
  if (isNaN(num)) {
    return "Field must be a number between -90 and 90";
  }
  if (num < -90 || num > 90) {
    return "Field must be a number between -90 and 90";
  }
  return null;
}

function checkIsBoolean(value) {
  return typeof value === "boolean" ? null : "Field must be a boolean";
}

function validateField(name, value) {
  const validator = validatorRegistry[name];
  return validator ? validator(value) : null;
}

export {
  checkEmpty,
  checkNumerical,
  checkUuid,
  checkEmail,
  checkIp,
  checkDeviceTypeInRange,
  checkBrandFamilyInRange,
  checkPreferenceTypeInRange,
  checkCapacityTariffTypeInRange,
  checkEnergyTariffTypeInRange,
  checkLatitude,
  checkLongitude,
  checkIsPositiveInt,
  checkIsValidNumber,
  checkOrientationTypeInRange,
  checkIsValidNumberInRange0_100,
  checkIsValidNumberInRange0_360,
  checkIsValidNumberInRangeMinus90_90,
  checkIsBoolean,
  checkLanguageCodeInRange
};

export default validateField;